import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { getChartsData as onGetChartsData } from "../../store/actions";

// LatestTransaction Component
import LatestTransaction from "./LatestTranaction";

const apiUrl = process.env.REACT_APP_API_URL;

const Dashboard = (props) => {
  const [phaseCounts, setPhaseCounts] = useState({});
  const [totalCards, setTotalCards] = useState(0);
  const [selectedPhase, setSelectedPhase] = useState(null);

  // Define the default order of phases for consistent ordering
  const phaseOrder = ["Leads", "New Client", "NTP", "WELCOME CALL", "OPERATION", "ENGINEERING DOCUMENTATION","ENGINEERING", "PERMITTING", "NTP BANK", "Desintalación","INSTALLATION", "INSPECTION", "PTO", "FINAL", "CLIENT SATISFACTION", "ON HOLD ", "ON HOLD FOLLOW UP", "CANCELLATION"];

  const DashboardProperties = createSelector(
    (state) => state.Dashboard,
    (dashboard) => ({ chartsData: dashboard.chartsData })
  );

  const { chartsData } = useSelector(DashboardProperties);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(onGetChartsData("yearly"));
  }, [dispatch]);

  // Fetch card data and set phase counts and total cards
  useEffect(() => {
    const fetchPhaseCounts = async () => {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const token = authUser?.token;
        if (!token) throw new Error("Authentication token not found");

        const response = await fetch(`${apiUrl}/api/data/table?page=1&limit=100000`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error("Failed to fetch records");

        const data = await response.json();
        const phaseCounter = {};

        (data.records).forEach((card) => {
          const phase = card.current_phase || "Unknown";
          phaseCounter[phase] = (phaseCounter[phase] || 0) + 1;
        });

        setPhaseCounts(phaseCounter);
        setTotalCards(data.totalCount);
      } catch (error) {
        console.error("Error fetching phase counts:", error);
      }
    };

    fetchPhaseCounts();
  }, []);

  // Handle phase click for filtering
  const handlePhaseClick = (phase) => {
    setSelectedPhase(phase === selectedPhase ? null : phase);
  };

  // Meta title
  document.title = "Dashboard | Sunwave";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Dashboards")} breadcrumbItem={props.t("Dashboard")} />

          <Row className="mb-4">
            <Col lg="12">
              <Row>
                {phaseOrder.map((phase, index) => (
                  <Col key={index} md="3" sm="6" className="mb-4">
                    <Card
                      className={`phase-card ${selectedPhase === phase ? "bg-primary text-white" : ""}`}
                      onClick={() => handlePhaseClick(phase)}
                      style={{ cursor: "pointer" }}
                    >
                      <CardBody>
                        <h5 className={`text-muted ${selectedPhase === phase ? "text-white" : ""}`}>{phase}</h5>
                        <h2>{phaseCounts[phase] || 0}</h2>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
                <Col md="3" sm="6" className="mb-4">
                  <Card className="phase-card bg-primary text-white">
                    <CardBody>
                      <h5 className="text-white">Total</h5>
                      <h2>{totalCards}</h2>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              {/* Pass the selected phase to LatestTransaction */}
              <LatestTransaction selectedPhase={selectedPhase} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);